export const photoEngagementService = {
  // Reactions
  async toggleReaction(harvestId, emoji) {
    const { default: api } = await import('../utils/api');
    const resp = await api.post(`/harvests/${harvestId}/reactions/toggle/`, { emoji });
    return resp.data;
  },
  async getReactionsSummary(harvestId) {
    const { default: api } = await import('../utils/api');
    const resp = await api.get(`/harvests/${harvestId}/reactions/`);
    return resp.data;
  },
  // Comments
  async listComments(harvestId, page = 1) {
    const { default: api } = await import('../utils/api');
    const resp = await api.get(`/harvests/${harvestId}/comments/?page=${page}`);
    return resp.data; // paginated
  },
  async addComment(harvestId, { text, parent_id = null }) {
    const { default: api } = await import('../utils/api');
    const payload = { text };
    if (parent_id) payload.parent_id = parent_id;
    const resp = await api.post(`/harvests/${harvestId}/comments/`, payload);
    return resp.data;
  },
  async editComment(commentId, { text }) {
    const { default: api } = await import('../utils/api');
    const resp = await api.patch(`/photo-comments/${commentId}/`, { text });
    return resp.data;
  },
  async deleteComment(commentId) {
    const { default: api } = await import('../utils/api');
    const resp = await api.delete(`/photo-comments/${commentId}/`);
    return resp.data;
  },
};

export const notificationsService = {
  async list(page = 1, filter = 'all') {
    const { default: api } = await import('../utils/api');
    const filterParam = filter && filter !== 'all' ? `&filter=${encodeURIComponent(filter)}` : '';
    const resp = await api.get(`/notifications/?page=${page}${filterParam}`);
    return resp.data; // paginated
  },
  async unreadCount() {
    const { default: api } = await import('../utils/api');
    const resp = await api.get('/notifications/unread-count/');
    return resp.data;
  },
  async dismiss(notificationId) {
    const { default: api } = await import('../utils/api');
    const resp = await api.post(`/notifications/${notificationId}/dismiss/`);
    return resp.data;
  },
  async dismissAll(filter = 'all') {
    const { default: api } = await import('../utils/api');
    const filterParam =
      filter && filter !== 'all' ? `?filter=${encodeURIComponent(filter)}` : '';
    const resp = await api.post(`/notifications/dismiss-all/${filterParam}`);
    return resp.data;
  },
};
